export async function generateSecureToken(): Promise<string> {
    const array = new Uint8Array(64);
    crypto.getRandomValues(array);
    const hashBuffer = await crypto.subtle.digest('SHA-512', array);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const base64 = btoa(hashArray.map(b => String.fromCharCode(b)).join(''));
    return base64;
  }